import { SimilarityFilter } from '../Modal/types';
import { NLS_SEARCH_KEY_LOCAL_STORAGE } from './constants';

export const getIsNLSSearchOnFromLocalStorage = () => {
	return Boolean(JSON.parse(localStorage.getItem(NLS_SEARCH_KEY_LOCAL_STORAGE) || 'false'));
};

export const emitSimilaritySearchEvent = (
	similarityFilter: SimilarityFilter,
	skipAddingToFilterbar: boolean,
) => {
	const searchAssetsEvent = new CustomEvent('react-overview_search-assets', {
		detail: {
			filters: { field: 'similaritySearch', ...similarityFilter },
			skipAddingToFilterbar,
		},
	});

	window.dispatchEvent(searchAssetsEvent);
};
